export default "__VITE_ASSET__D12kWWwI__"